export default "__VITE_ASSET__edd1ff7e__"